// Typeahead experiments
export const HA_TYPEAHEAD_SCROLL_TO_TOP = 'HA_TYPEAHEAD_SCROLL_TO_TOP';
export const HA_TYPEAHEAD_HIGHLIGHTS = 'ha_typeahead_highlights';
export const HA_TYPEAHEAD_TWO_LINE_DISPLAY = 'ha_typeahead_two_line_display';
